import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Icon, Row, Col, Spin, Card, Input, Button } from 'antd'
import { Queries } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgcontact from '../../../assets/images/contact.jpg'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'

const { Text, Title } = Typography
const { Search } = Input;

class Contact extends React.Component {

    state = {
        dataContact: [],
        visibleModal: false,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        preLoad:false,
        search: ""
    }

    fetchListContactUs = async (search) => {
        const { client, location } = this.props
        await this.setState({
            preLoad: true
        })
        const { data, errors } = await client.query({
            query: Queries.fetchListContactUs,
            variables: {
				contactUsCategoryId: location.pathname.split('/')[3],
                search
			}
        })

        console.log(data)
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        await this.setState({
            dataContact: data.fetchListContactUs,
            preLoad: false
        })
    }

    onChangeSearch = async (values) =>{
        this.setState({
            search: values
        })
    }

    onClickSearch = async () =>{
        const { search } = this.state
        await this.fetchListContactUs(search)
    }

    async componentDidMount() {
        const { location } = this.props
        await this.fetchListContactUs('')
    }


    render() {
        const { match, location } = this.props
        const { dataContact, preLoad } = this.state
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div id="page-contact">
                    <Row gutter={20} className="mb-3">
                        <Col span={18}>
                            <Search
                                placeholder=""
                                onChange={e => this.onChangeSearch(e.target.value) }
                            />
                        </Col>
                        <Col span={4}>
                            <Button 
                                type="primary" 
                                htmlType="submit" 
                                className="color-white text-right fick-button-height-select" 
                                onClick={ this.onClickSearch } 
                            >
                                <Icon type="search" /> ค้นหา
                            </Button>
                        </Col>
                    </Row>
                        {
                            dataContact.length !== 0 &&
                                dataContact.map((values, keys) =>
                                    <Row gutter={20}>
                                        <Col>
                                            <Link to={ '/contact/department/'+location.pathname.split('/')[3]+'/'+values.contactUsId}>
                                                <Card className="mb-3 card-hover-custom">
                                                    <div>
                                                        <Title level={4} className="mr-2 pr-1 mb-1" style={{display:"inline-block"}}>
                                                        { values.contactUsTitle }
                                                        </Title>
                                                    </div>
                                                    {/* <Text className="font-italic">วันที่ 24 กันยายน 2563</Text><br></br> */}
                                                </Card>
                                            </Link>
                                        </Col>
                                    </Row>
                                )
                            ||
                            ( dataContact.length == 0 && !preLoad ) &&
                                <Row gutter={20}>
                                    <Col xs={24} sm={24} align="center">
                                        <Text>
                                            ไม่พบข้อมูล
                                        </Text>	
                                    </Col>
                                </Row>
                            ||
                                <Row gutter={20}>
                                    <Col align="center" className="mt-5">
                                        <Spin size="large" />
                                    </Col>
                                </Row>
                        }
                </div>
            </Container>
        )
    }
}

Contact.propTypes = {
    //
}

export default withApollo(Contact)